const RESOURCES_DE = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "BTP Pro Card",
  CACES: "CACES",
  CE_CERTIFICATE: "CE-Zertifikat",
  CE_CERTIFICATION: "CE-Zertifizierung",
  DELIVERY: "Lieferung",
  DEPARTURE_NOTE: "Ausgabeschein",
  DRIVING_AUTHORIZATION: "Fahrberechtigung",
  DUE: "Fällig",
  documentsStatus: "Dokumentenstatus",
  EMAILS: "E-Mail",
  HOUR_SHEET: "Stundenzettel",
  ICON: "Symbol",
  ID: "ID",
  IDENTITY: "Identität",
  INSURANCE: "Versicherung",
  INVOICE: "Rechnung",
  KBIS: "Kbis",
  LIFTING_PLAN: "Hebearbeitsplan",
  LIFTING_SHEET: "Hebeblatt",
  LOGO: "Logo",
  MACHINE_SPECIFICATIONS: "Maschinenspezifikationen",
  MAINTENANCE_LOG: "Wartungsprotokoll",
  MAINTENANCE_LOG_EXCERPT: "Auszug aus dem Wartungsprotokoll",
  MEDICAL_CERTIFICATE: "Ärztliches Attest",
  OPERATOR_DOCUMENT: "Bedienungsdokument",
  OTHER: "Sonstiges",
  PGI: "PGI",
  PHOTO: "Foto",
  PIC: "PIC",
  PURCHASE_ORDER: "Bestellung",
  QUOTATION: "Angebot",
  RETURN_NOTE: "Rückgabeschein",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "Unterzeichnete Mietanfrage",
  SPECIFIC_TRAINING: "Spezifische Schulung",
  TECHNICAL_SHEET: "Technisches Datenblatt",
  USED_MACHINE_CERTIFICATE: "Gebrauchtmaschinen-Zertifikat",
  USER_MANUAL: "Benutzerhandbuch",
  VGP: "VGP",
  WORK_ORDER: "Arbeitsauftrag",
} as const;

export default RESOURCES_DE;
